export enum TokenErrorEnum {
  CLASS_NOT_STARTED = "4031",
  CLASS_ENDED = "4032",
  PAYMENT_NOT_CONFIRMED = "4033",
  PRACTITIONER_NOT_LIVE = "4034",
}
